const logoUrl = new URL('../assets/ichi-logo.jpg', import.meta.url).toString();

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <img src={logoUrl} alt="ICAI Logo" className="footer__icai-logo" />
          <span className="footer__brand-name">Prabhu Mallya &amp; Associates</span>
        </div>
        <p className="footer__copy">
          © {new Date().getFullYear()} Prabhu Mallya &amp; Associates, Chartered Accountants. All rights reserved.
        </p>
        <p className="footer__disclaimer">
          This website is for informational purposes only and does not constitute professional advice.
        </p>
      </div>
    </footer>
  );
}
